export default [{
        routerName: 'weblogDetail',
        routerParams: 'id',
        routerQuery: '',
        routerSlug: 'slug',
        listRouterName: 'weblogs',
        linkable_type: 'Modules\\Blog\\Entities\\Post',
    },
    {
        routerName: 'weblogs',
        routerParams: '',
        routerQuery: 'category',
        routerSlug: '',
        listRouterName: 'weblogs',
        linkable_type: 'Modules\\Blog\\Entities\\Category',
    },
    {
        routerName: 'page',
        routerParams: 'id',
        routerQuery: '',
        routerSlug: '',
        listRouterName: '',
        linkable_type: 'Modules\\Page\\Entities\\Page',
    },
    {
        routerName: 'aboutUs',
        routerParams: '',
        routerQuery: '',
        routerSlug: '',
        listRouterName: 'aboutUs',
        linkable_type: 'Custom\\AboutUs',
    },
    {
        routerName: 'contactUs',
        routerParams: '',
        routerQuery: '',
        routerSlug: '',
        listRouterName: 'contactUs',
        linkable_type: 'Custom\\ContactUs',
    },
]